import React from 'react';

const SmartLinkModal = ({
    candidate,
    remotePerson,
    onConfirmLink,
    onCancel,
    onIgnore
}) => {
    if (!candidate || !remotePerson) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onCancel}></div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6">

                    <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                            <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>

                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                            <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                Existing Player Found
                            </h3>
                            <div className="mt-2">
                                <p className="text-sm text-gray-500">
                                    We found a player with a similar name who already has a photo.
                                    Is this the same person as <strong>{remotePerson.nameFullLatin}</strong>?
                                </p>
                            </div>

                            {/* Comparison Grid */}
                            <div className="mt-6 grid grid-cols-2 gap-4 border rounded-lg overflow-hidden">

                                {/* Existing Player (Candidate) */}
                                <div className="bg-gray-50 p-4 border-r border-gray-200">
                                    <h4 className="text-xs font-bold text-gray-500 uppercase mb-2">Existing Record</h4>

                                    <div className="flex items-center gap-3">
                                        <div className="h-16 w-16 bg-gray-200 rounded-md overflow-hidden flex-shrink-0">
                                            {(candidate.photo_url || candidate.uploaded_photo_url) ? (
                                                <img
                                                    src={candidate.photo_url || candidate.uploaded_photo_url}
                                                    alt="Existing"
                                                    className="h-full w-full object-cover"
                                                />
                                            ) : (
                                                <div className="h-full w-full flex items-center justify-center text-gray-400">?</div>
                                            )}
                                        </div>
                                        <div>
                                            <p className="font-bold text-gray-900">{candidate.player_name}</p>
                                            <p className="text-xs text-gray-500">{candidate.event_name}</p>
                                            <p className="text-xs text-gray-500">{candidate.team}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* New Sportradar Person */}
                                <div className="bg-white p-4">
                                    <h4 className="text-xs font-bold text-blue-500 uppercase mb-2">Sportradar (Live)</h4>

                                    <div className="flex items-center gap-3">
                                        <div className="h-16 w-16 bg-gray-100 rounded-md overflow-hidden flex-shrink-0 border border-blue-100">
                                            {remotePerson.images && remotePerson.images.length > 0 ? (
                                                <img src={remotePerson.images[0].url} alt="Remote" className="h-full w-full object-cover" />
                                            ) : (
                                                <div className="h-full w-full flex items-center justify-center text-gray-300 text-xs">No Photo</div>
                                            )}
                                        </div>
                                        <div>
                                            <p className="font-bold text-gray-900">{remotePerson.nameFullLatin}</p>
                                            <p className="text-xs text-gray-500">ID: {remotePerson.personId}</p>
                                            <p className="text-xs text-gray-500">{remotePerson.nationality}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="mt-4 bg-yellow-50 p-3 rounded-md text-xs text-yellow-800">
                                <strong>Recommendation:</strong> If you select "Yes, Link Them", we will update the old record with the Sportradar ID and use its photo for this new entry.
                            </div>

                        </div>
                    </div>

                    <div className="mt-8 sm:mt-6 sm:flex sm:flex-row-reverse gap-2">
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={() => onConfirmLink(candidate)}
                        >
                            Yes, Link Them
                        </button>
                        <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={onIgnore}
                        >
                            No, Create New
                        </button>
                        <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-gray-400 hover:text-gray-500 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmartLinkModal;
